import React from 'react'
import CategoryList from './CategoryList'
import '../styles/Categories.css'

const Categories = () => (
  <ul className="categories">
    <CategoryList />
  </ul>
)

export default Categories



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Categories/index.jsx